import { SvgIcon, SvgIconProps } from "@mui/material";

export const RepostIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "19", height: "19", fill: "none" }}
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
    >
      <path
        d="M8.33325 0.833008L10.8333 3.33301M10.8333 3.33301L8.33325 5.83301M10.8333 3.33301H4.83325C3.43312 3.33301 2.73305 3.33301 2.19828 3.60549C1.72787 3.84517 1.34542 4.22763 1.10574 4.69803C0.833252 5.23281 0.833252 5.93288 0.833252 7.33301V12.083C0.833252 12.47 0.833252 12.6635 0.85464 12.826C1.00233 13.9478 1.8851 14.8306 3.00694 14.9783C3.16939 14.9997 3.3629 14.9997 3.74992 14.9997M7.49992 14.9997H13.4999C14.9 14.9997 15.6001 14.9997 16.1349 14.7272C16.6053 14.4875 16.9878 14.1051 17.2274 13.6347C17.4999 13.0999 17.4999 12.3998 17.4999 10.9997V6.24967C17.4999 5.86266 17.4999 5.66915 17.4785 5.50669C17.3308 4.38486 16.4481 3.50209 15.3262 3.3544C15.1638 3.33301 14.9703 3.33301 14.5833 3.33301M7.49992 14.9997L9.99992 17.4997M7.49992 14.9997L9.99992 12.4997"
        stroke="#707070"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const MidDotIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "3", height: "3", fill: "none" }}
      width="3"
      height="3"
      viewBox="0 0 3 3"
      fill="none"
    >
      <circle cx="1.5" cy="1.5" r="1.5" fill="#707070" />
    </SvgIcon>
  );
};

export const SendCommentButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M8.75036 10.0003H4.16702M4.09648 10.2432L2.15071 16.0555C1.99785 16.5121 1.92142 16.7404 1.97627 16.881C2.0239 17.0031 2.1262 17.0957 2.25244 17.1309C2.3978 17.1715 2.61736 17.0727 3.05647 16.8751L16.9827 10.6083C17.4113 10.4154 17.6256 10.319 17.6918 10.185C17.7494 10.0686 17.7494 9.93203 17.6918 9.81564C17.6256 9.68168 17.4113 9.58524 16.9827 9.39237L3.05161 3.12342C2.61383 2.92641 2.39493 2.82791 2.24971 2.86832C2.1236 2.90341 2.0213 2.99573 1.97351 3.1176C1.91847 3.25793 1.99408 3.48574 2.14531 3.94137L4.09702 9.82159C4.12299 9.89984 4.13598 9.93897 4.14111 9.97899C4.14565 10.0145 4.14561 10.0504 4.14097 10.0859C4.13574 10.1259 4.12265 10.165 4.09648 10.2432Z"
        stroke="#475467"
        strokeWidth="1.66667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};

export const JoinChallengeButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "20", height: "20", fill: "none" }}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7776 4.32701C16.9846 4.15449 17.2728 4.11728 17.5168 4.23159C17.7608 4.34589 17.9167 4.59107 17.9167 4.86049V14.5826C17.9167 14.8521 17.7608 15.0972 17.5168 15.2115C17.2728 15.3258 16.9846 15.2886 16.7776 15.1161L13.75 12.5933V13.1939C13.75 14.3446 12.8173 15.2772 11.6667 15.2772H3.33333C2.18276 15.2772 1.25 14.3446 1.25 13.1939V6.24938C1.25 5.09881 2.18276 4.16605 3.33333 4.16605H11.6667C12.8173 4.16605 13.75 5.09881 13.75 6.24938V6.85009L16.7776 4.32701ZM10.9721 7.6382C11.3557 7.6382 11.6666 7.32728 11.6666 6.94373C11.6666 6.56018 11.3557 6.24925 10.9721 6.24925C10.5886 6.24925 10.2778 6.56018 10.2778 6.94373C10.2778 7.32728 10.5886 7.6382 10.9721 7.6382Z"
        fill="#111111"
      />
    </SvgIcon>
  );
};

export const ChallengeLockedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "10", height: "14", fill: "none" }}
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.64303 8.02538C5.19045 8.02538 5.63416 8.46909 5.63416 9.01651C5.63416 9.35778 5.46168 9.65873 5.19909 9.83698V11.5867H4.07915L4.07904 9.83143C3.82106 9.6525 3.65202 9.3543 3.65202 9.01648C3.65191 8.46906 4.09561 8.02535 4.64303 8.02535L4.64303 8.02538ZM0.959553 5.56903C0.959553 5.62261 0.957594 5.59046 0.963816 5.64058C0.730613 5.69163 0.522288 5.80892 0.359499 5.97174C0.137357 6.19388 0 6.50072 0 6.83969V12.7725C0 13.1115 0.13734 13.4184 0.359499 13.6405C0.581658 13.8626 0.888483 14 1.22745 14H8.05846C8.39743 14 8.70437 13.8627 8.92642 13.6405C9.14856 13.4184 9.28592 13.1115 9.28592 12.7725V6.83969C9.28592 6.50072 9.14858 6.19378 8.92642 5.97174C8.76361 5.80893 8.55518 5.69164 8.3221 5.64058C8.32832 5.59046 8.32636 5.62261 8.32636 5.56903V3.68358C8.32636 3.19999 8.23154 2.72289 8.04649 2.27605C7.86122 1.82889 7.58978 1.42125 7.24744 1.07892C6.90514 0.736617 6.49748 0.465134 6.05031 0.279868C5.60359 0.0948272 5.12638 0 4.64279 0C3.66272 0 2.73108 0.385987 2.03825 1.07891C1.34533 1.77183 0.959339 2.7035 0.959339 3.68357L0.959553 5.56903ZM7.1446 5.61224H2.14176C2.14314 5.6021 2.14222 5.60555 2.14222 5.56903V3.68358C2.14222 3.01785 2.404 2.38586 2.87467 1.91508C3.34534 1.44441 3.97732 1.18263 4.64305 1.18263C4.97187 1.18263 5.29668 1.24519 5.60064 1.37101C5.90413 1.49671 6.17938 1.6829 6.41155 1.91507C6.64372 2.14723 6.82992 2.42249 6.95561 2.72598C7.08154 3.02993 7.1441 3.35472 7.1441 3.68357V5.56902C7.14399 5.60555 7.14307 5.60209 7.14456 5.61223L7.1446 5.61224Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export const ChallengePlayButtonIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      style={{ width: "32", height: "32", fill: "none" }}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
    >
      <path
        d="M10 16.0009V7.91797L17 11.9594L24 16.0009L17 20.0424L10 24.0838V16.0009Z"
        fill="white"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </SvgIcon>
  );
};
